export const ApplicationHistoryFilterKeys = {
  ACTION_ID: 'actionId',
  ACTION_TYPE_ID: 'actionTypeId',
  END_DATE: 'endDate',
  ERROR_TYPE: 'errorType',
  // does not exist in history filter bar
  NOTIFICATION_TYPE: 'notificationType',
  OBJECT_ID: 'objectId',
  RANGE_TYPE: 'rangeType',
  REVISION_END_TIMESTAMP: 'revisionEndTimestamp',
  REVISION_ID: 'revisionId',
  REVISION_START_TIMESTAMP: 'revisionStartTimestamp',
  START_DATE: 'startDate'
};